import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';

@Injectable()
export class DownloadUrlsService {
    private readonly apiUrl: string;

    constructor() {
        this.apiUrl = environment.apiUrl;
    }

    getRegistrationsExportUrl(eventId: number): string {
        return this.apiUrl + '/download/event/' + eventId + '/registrations';
    }

    getUserGroupContractsExportUrl(usergroupHash: string): string {
        return this.apiUrl + '/download/usergroup/' + usergroupHash + '/contracts';
    }

    getUserGroupEmployeesExportUrl(usergroupHash: string, type: string): string {
        return this.apiUrl + '/download/user-group/' + usergroupHash + '/users/' + type;
    }

    getUserGroupInsuredEmployeesExportUrl(usergroupHash: string): string {
        return this.apiUrl + '/download/usergroup/' + usergroupHash + '/insured-employees';
    }

    getUserGroupInsuredEmployeeConfirmationsExportUrl(usergroupHash: string): string {
        return this.apiUrl + '/download/usergroup/' + usergroupHash + '/insured-employee-confirmations';
    }

    getUserGroupInvoicesExportUrl(usergroupHash: string): string {
        return this.apiUrl + '/download/usergroup/' + usergroupHash + '/invoices';
    }

    getUserGroupPurchaseLogsExportUrl(usergroupHash: string): string {
        return this.apiUrl + '/download/usergroup/' + usergroupHash + '/purchaselogs';
    }

    getUserGroupTaxReportsExportUrl(usergroupHash: string): string {
        return this.apiUrl + '/download/usergroup/' + usergroupHash + '/tax-exception';
    }

    getUserGroupTransactionsExportUrl(usergroupHash: string): string {
        return this.apiUrl + '/download/usergroup/' + usergroupHash + '/transactions';
    }

    getUserTransactionsExportUrl(userHash: string): string {
        return this.apiUrl + '/download/user/' + userHash + '/transactions';
    }
}
